module.exports = __webpack_public_path__ + "img/28_30.8849d419.png";